<app-header></app-header>

<div class="min-h-screen tema-claro">
  <div class="max-w-[1400px] mx-auto p-6">

    <!-- Breadcrumb -->
    <div class="mb-6 flex items-center gap-2 text-xs" style="color: var(--tx-2)">
      <a routerLink="/home" class="hover:underline" style="color: var(--brand-primary)">Início</a>
      <span>/</span>
      <a routerLink="/lancamentos-financeiros" class="hover:underline" style="color: var(--brand-primary)">Lançamentos Financeiros</a>
      <span>/</span>
      <span class="font-semibold" style="color: var(--tx)">Análise de Pendências</span>
    </div>

    <div class="bg-white rounded-2xl shadow-sm overflow-hidden" style="border: 1px solid var(--flua-borda)">

      <!-- Header -->
      <div class="px-6 py-4 flex items-center justify-between" style="background-color: var(--thead)">
        <div class="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
          </svg>
          <span class="font-semibold text-sm text-white">Análise de Pendências</span>
        </div>
        <button (click)="voltar()" class="p-1 text-white hover:opacity-75">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Toolbar -->
      <div class="px-6 py-4 flex flex-wrap items-end gap-3" style="border-bottom: 1px solid var(--flua-borda); background-color: var(--flua-rodape)">
        <div>
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">Unidade</label>
          <select [(ngModel)]="cdEstab" class="px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda); min-width: 200px">
            <option [ngValue]="0">Todas</option>
            <option *ngFor="let u of unidades" [ngValue]="u.id">{{ u.name }}</option>
          </select>
        </div>
        <div>
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">De</label>
          <input type="date" [(ngModel)]="dtInicial" class="px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda)"/>
        </div>
        <div>
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">Até</label>
          <input type="date" [(ngModel)]="dtFinal" class="px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda)"/>
        </div>
        <div class="flex-1 min-w-[180px]">
          <label class="text-[11px] font-semibold mb-1 block" style="color: var(--tx)">Filtro por usuário</label>
          <input type="text" [(ngModel)]="filtroUsuario" placeholder="Digite para filtrar"
                 class="w-full px-3 py-1.5 text-sm rounded-lg" style="border: 1px solid var(--flua-borda)"/>
        </div>
        <button (click)="atualizarTudo()"
                class="px-4 py-1.5 rounded-lg text-xs font-semibold text-white" style="background-color: var(--brand-primary)">
          Atualizar
        </button>
        <button (click)="vincularTodos()" [disabled]="vinculando"
                class="px-4 py-1.5 rounded-lg text-xs font-semibold flex items-center gap-1.5"
                style="border: 1px solid var(--brand-secondary); color: var(--brand-secondary); background-color: #f0fdf4">
          <div *ngIf="vinculando" class="animate-spin rounded-full h-3 w-3 border-b-2" style="border-color: var(--brand-secondary)"></div>
          {{ vinculando ? 'Vinculando...' : 'Vincular Saldos' }}
        </button>
      </div>

      <!-- Mensagem -->
      <div *ngIf="mensagem" class="px-6 py-2 text-xs"
           [style.backgroundColor]="mensagemTipo === 'ok' ? '#dcfce7' : mensagemTipo === 'err' ? '#fef2f2' : '#eff6ff'"
           [style.color]="mensagemTipo === 'ok' ? '#166534' : mensagemTipo === 'err' ? '#991b1b' : '#1e40af'">
        {{ mensagem }}
      </div>

      <!-- Tabs -->
      <div class="flex gap-0 px-6" style="border-bottom: 2px solid var(--flua-borda)">
        <button (click)="trocarTab('PROVISORIO')"
                class="px-4 py-2.5 text-xs font-semibold flex items-center gap-2"
                [style.color]="tabAtual === 'PROVISORIO' ? 'var(--brand-primary)' : '#4A5D6B'"
                [style.borderBottom]="tabAtual === 'PROVISORIO' ? '2px solid var(--brand-primary)' : '2px solid transparent'"
                style="margin-bottom: -2px">
          Provisório
          <span class="px-2 py-0.5 rounded-full text-[10px]"
                [style.backgroundColor]="tabAtual === 'PROVISORIO' ? 'var(--brand-primary)' : '#E5DFD4'"
                [style.color]="tabAtual === 'PROVISORIO' ? 'white' : '#2F4556'">
            {{ badge('PROVISORIO') }}
          </span>
        </button>
        <button (click)="trocarTab('SALDO_PENDENTE')"
                class="px-4 py-2.5 text-xs font-semibold flex items-center gap-2"
                [style.color]="tabAtual === 'SALDO_PENDENTE' ? 'var(--brand-primary)' : '#4A5D6B'"
                [style.borderBottom]="tabAtual === 'SALDO_PENDENTE' ? '2px solid var(--brand-primary)' : '2px solid transparent'"
                style="margin-bottom: -2px">
          Saldo Pendente
          <span class="px-2 py-0.5 rounded-full text-[10px]"
                [style.backgroundColor]="tabAtual === 'SALDO_PENDENTE' ? 'var(--brand-primary)' : '#E5DFD4'"
                [style.color]="tabAtual === 'SALDO_PENDENTE' ? 'white' : '#2F4556'">
            {{ badge('SALDO_PENDENTE') }}
          </span>
        </button>
        <button (click)="trocarTab('SEM_NF_TITULO')"
                class="px-4 py-2.5 text-xs font-semibold flex items-center gap-2"
                [style.color]="tabAtual === 'SEM_NF_TITULO' ? 'var(--brand-primary)' : '#4A5D6B'"
                [style.borderBottom]="tabAtual === 'SEM_NF_TITULO' ? '2px solid var(--brand-primary)' : '2px solid transparent'"
                style="margin-bottom: -2px">
          Sem NF / Título
          <span class="px-2 py-0.5 rounded-full text-[10px]"
                [style.backgroundColor]="tabAtual === 'SEM_NF_TITULO' ? 'var(--brand-primary)' : '#E5DFD4'"
                [style.color]="tabAtual === 'SEM_NF_TITULO' ? 'white' : '#2F4556'">
            {{ badge('SEM_NF_TITULO') }}
          </span>
        </button>
      </div>

      <!-- Tabela -->
      <div class="overflow-x-auto">
        <table class="w-full text-xs">
          <thead>
            <tr style="background-color: var(--thead)">
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Paciente</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Atend</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Conta</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Data</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Unidade</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Convênio</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Categoria</th>
              <th class="px-3 py-2.5 text-right text-white font-semibold whitespace-nowrap">Vl Total</th>
              <th class="px-3 py-2.5 text-right text-white font-semibold whitespace-nowrap">Vl Saldo</th>
              <th class="px-3 py-2.5 text-right text-white font-semibold whitespace-nowrap">Vl Saldo Pac.</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Status</th>
              <th class="px-3 py-2.5 text-left text-white font-semibold whitespace-nowrap">Usuário</th>
              <th *ngIf="tabAtual === 'SALDO_PENDENTE'" class="px-3 py-2.5 text-center text-white font-semibold whitespace-nowrap">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading[tabAtual]">
              <td [attr.colspan]="tabAtual === 'SALDO_PENDENTE' ? 13 : 12" class="px-4 py-8 text-center" style="color: var(--tx-2)">
                Carregando...
              </td>
            </tr>
            <tr *ngIf="!loading[tabAtual] && pendenciasFiltradas(tabAtual).length === 0">
              <td [attr.colspan]="tabAtual === 'SALDO_PENDENTE' ? 13 : 12" class="px-4 py-8 text-center" style="color: var(--tx-2)">
                Nenhuma pendência encontrada.
              </td>
            </tr>
            <tr *ngFor="let p of pendenciasFiltradas(tabAtual)" style="border-bottom: 1px solid var(--flua-borda)">
              <td class="px-3 py-2" style="color: var(--tx)">{{ p.nmPaciente }}</td>
              <td class="px-3 py-2 font-mono" style="color: var(--tx-2)">{{ p.nrAtendimento }}</td>
              <td class="px-3 py-2 font-mono" style="color: var(--tx-2)">{{ p.nrInternoConta }}</td>
              <td class="px-3 py-2 whitespace-nowrap" style="color: var(--tx-2)">{{ formatDate(p.dtEntrada) }}</td>
              <td class="px-3 py-2 whitespace-nowrap" style="color: var(--tx-2)">{{ p.nmUnidade }}</td>
              <td class="px-3 py-2" style="color: var(--tx-2)">{{ p.nmConvenio || '—' }}</td>
              <td class="px-3 py-2" style="color: var(--tx-2)">{{ p.nmCategoria || '—' }}</td>
              <td class="px-3 py-2 text-right font-mono whitespace-nowrap" style="color: var(--tx)">{{ formatCurrency(p.vlTotal) }}</td>
              <td class="px-3 py-2 text-right font-mono whitespace-nowrap" style="color: #991b1b"><strong>{{ formatCurrency(p.vlSaldo) }}</strong></td>
              <td class="px-3 py-2 text-right font-mono whitespace-nowrap" style="color: #00AC70">{{ formatCurrency(p.vlSaldoPaciente) }}</td>
              <td class="px-3 py-2 whitespace-nowrap">
                <span class="px-2 py-0.5 rounded text-[10px] font-semibold" style="background-color: var(--flua-fundo); color: var(--tx-2)">
                  {{ p.statusCp || '—' }}
                </span>
              </td>
              <td class="px-3 py-2 whitespace-nowrap" style="color: var(--tx-2)">{{ p.usuario || '—' }}</td>
              <td *ngIf="tabAtual === 'SALDO_PENDENTE'" class="px-3 py-2 text-center">
                <button (click)="vincularConta(p)" [disabled]="vinculandoConta === p.nrInternoConta"
                        class="px-3 py-1 rounded text-[11px] font-semibold flex items-center gap-1.5 mx-auto"
                        [style.backgroundColor]="vinculandoConta === p.nrInternoConta ? '#d1fae5' : 'var(--brand-secondary)'"
                        [style.color]="vinculandoConta === p.nrInternoConta ? '#065f46' : 'white'"
                        [disabled]="p.vlSaldoPaciente <= 0">
                  <div *ngIf="vinculandoConta === p.nrInternoConta" class="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                  {{ vinculandoConta === p.nrInternoConta ? 'Vinculando...' : 'Vincular' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>
